import type { CSSProperties } from 'react';

/**
 * 🚨 The live preview is a PICTURE, not a form — nothing in it may be operated.
 *
 * `mode: 'preview'` passes no handlers, and that was believed to be enough. It is not.
 * `renderNubeTree` renders a controlled `<select value={…}>` whose `onChange` does nothing, and
 * React only restores a controlled value when something triggers a re-render. With no handler
 * there is no state change, so no re-render, so the DOM simply KEEPS whatever option the merchant
 * picked. Reported from a live Designer: with a coverage applied, a province was selectable and
 * stuck, while its city stayed empty — the city's options come from rebuilding the tree against
 * the chosen province, which in an inert preview never happens. A half-working control is worse
 * than none, because it invites the merchant to test data entry in a surface that cannot do it.
 *
 * `pointer-events` rather than the `disabled` attribute, deliberately: a disabled control is
 * greyed by the browser — Safari fades a disabled `<select>` outright — which would misreport the
 * merchant's own colours in the one surface whose entire job is showing them. This blocks every
 * mouse and touch interaction while leaving the rendering byte-for-byte identical.
 *
 * Scrolling is unaffected: the wheel acts on the scroll container that owns the preview, which is
 * an ancestor of this element rather than a descendant.
 */
export const PREVIEW_SURFACE_STYLE: CSSProperties = {
  pointerEvents: 'none',
};
